import IdleTimer, { useIdleTimer,IIdleTimer } from 'react-idle-timer'
import React, { useState, useRef, useEffect } from 'react'
import ActionModal from '../../ui/modal/ActionModal'
import { useNavigate } from 'react-router-dom'
import { useRefreshTokenMutation } from '../../services/loginservices'
import { isTokenExpired, parseJwt } from '../utilities/utils'
import { BASE_URLS, PLATFORM_TYPE, USERTYPE } from '../../constants/constants'
import axios from 'axios'
import { useIdlePrompt } from '../utilities/useIdlePrompt'
import { getCookie, setCookie } from '../utilities/cookieUtils'

const IdlePromptModal = ({ onContinue, onLogout,countdown,showPrompt }) => (
  <ActionModal
  show={showPrompt}
  sessionButton="block"
  actionButton="none"
  modalBody={
    countdown < 40 && (
      <div className="fixed w-full h-screen bg-gray-400 bg-opacity-80 flex justify-center items-center">
        <div className="bg-white opacity-100  rounded-lg flex flex-col justify-center items-center">
          <div className="text-center text-xl">
            {/* <h6>You will be logged out in</h6> */}
            <h1 style={{ fontWeight: 400, color: "red" }}>
               {countdown}s{" "}
            </h1>
          </div>
          <p className="w-[80%] text-center py-3">
            You have been inactive for last 15 minutes. In order to continue
            using the site ,Please click anywhere within the browser?
          </p>
        </div>
      </div>
    )
  }
  modalHeading={
    <div className="text-center text-xl">
      <h6>You will be logged out in</h6>
    </div>
  }
/>
);

const SessionIdleTimer = () => {
  let navigate = useNavigate();
  const sessionTimeoutRef = useRef(null);
  const [getRefreshToken] = useRefreshTokenMutation();
  const EXPIRY_THRESHOLD_SECONDS = 35;
  const IDLE_TIMEOUT_MS = 25 * 60 * 1000
  const WARNING_BEFORE_LOGOUT_MS = (EXPIRY_THRESHOLD_SECONDS * 1000) - 5000;
  const [resetTimer, setResetTimer] = useState(false);
  const [show, setShow] = useState(false);
  const [showMsg, setShowMsg] = useState("");
  const userrole = localStorage?.userrole;
  const [remaining,setremaining]= useState();
   const { showPrompt, handleContinue, handleLogout ,countdown} = useIdlePrompt({
    onContinue: () => {
    },
    onLogout: () => {
      logMeoutConfirm()
    },
  });

  // const onIdle = () => {
  //  logout()
  // };
  // const handleAction = (event) => {
  // };
 
  //  useEffect(() => {
  //   const interval = setInterval(
  //     () => setremaining(Number((getRemainingTime() / 1000).toFixed(0))),
  //     1000
  //   );
  //   return () => clearInterval(interval);
  // }, [getRemainingTime]);




  useEffect(() => {
    
    if (getTime()) {
      handleShow();
    }

    const interval = setInterval(() => {
      if (getTime()) {
        handleShow();
      }
    }, 10000); // 1 min
    return () => clearInterval(interval);

  }, [resetTimer]);







  const getTime = (date) => {
  
    if (userrole === "record" || userrole === "unit") {
      return false;
    }
    const token = localStorage.getItem("access_token");
    let loginTime = parseJwt(token).iat;
    let currentTime = Math.floor(Date.now() / 1000);
    let expiryTime = localStorage.expiry - EXPIRY_THRESHOLD_SECONDS;
    console.log(currentTime - loginTime >= expiryTime,currentTime - loginTime,"currentTime - loginTime",currentTime,"-cuur" ,loginTime ,"---login" ,expiryTime,"-exp")
    return currentTime - loginTime >= expiryTime;
  };
  const logout = () => {
    setShow(false)
    navigate('/login')
    clearTimeout(sessionTimeoutRef.current)
  }
  // function handleClose() {
  //   clearTimeout(sessionTimeoutRef.current)
  //   setShow(false)
  // }
  function keepMeActive() {
    let appName = ''
    if (
      userrole === 'ro' ||
      userrole === 'cs'
    ){
      appName=USERTYPE.ETPBMS
    }else if( userrole === 'nodal' ||
    userrole === 'unit' ||
    userrole === 'record'){
      appName=USERTYPE.SVP
    }
    else{
      appName=USERTYPE.ERONET
    }
      if (
        localStorage.getItem('refreshToken') &&
        !isTokenExpired(parseJwt(localStorage.getItem('refreshToken')).exp)
      ) {
        getRefreshToken({
          applicationName: appName,
          refreshToken: localStorage.getItem('refreshToken'),
        })
          .then((result) => {
            if (result && result.data && result.data.access_token) {
              localStorage.setItem('access_token', result.data?.access_token)
              localStorage.setItem('refreshToken', result.data?.refresh_token)
              localStorage.setItem(
                "rtkn_bnd",
                result.data?.rtkn_bnd
              );
              localStorage.setItem(
                "atkn_bnd",
                result.data?.atkn_bnd
              );
              localStorage.setItem("expiry", result.data?.expires_in);
              localStorage.setItem("refreshExpiry", result.data?.refresh_expires_in);
              setCookie('REFRESH_SYNC_V1')
              localStorage.setItem("last_seen_refresh_sync_v1",getCookie("REFRESH_SYNC_V1"))
              setShow(false)
              setResetTimer(!resetTimer)
            } else {
              logout()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
  }

  async function logMeoutConfirm () {
   try{
    let response = await axios.post(
      BASE_URLS.LOGIN_BASE_URL + "api/v1/authn-sso/logout",
      {
        userName : parseJwt(localStorage.getItem("access_token")).preferred_username, 
        id : parseJwt(localStorage.getItem("access_token")).session_state
      },
      {
        withCredentials:true,
        headers: {
          'Content-Type': 'application/json',
          'applicationName':
          (localStorage.userrole=="cs"||localStorage.userrole=="ro")?USERTYPE.ETPBMS:
          (localStorage.userrole=="nodal"||localStorage.userrole=="record"||
          localStorage.userrole=="unit")?USERTYPE.SVP:USERTYPE.ERONET,            
          'Authorization': 'Bearer ' + localStorage?.access_token,
          // 'userName':parseJwt(localStorage?.access_token)?.preferred_username,            
          'refreshToken': localStorage?.refreshToken,      
          "atkn_bnd": localStorage?.atkn_bnd,
          "rtkn_bnd": localStorage?.rtkn_bnd,
          "channelidobo": "ETPBMS", 
                 "PLATFORM-TYPE":PLATFORM_TYPE
        },
      }
    );
    if (response.status == 200) {
     localStorage.clear()
      navigate('/login')
    } else {
     localStorage.clear()
      navigate('/login')
    }
   }
   catch(error){
   localStorage.clear()
    navigate('/login')
   }
  };

  useEffect(() => {
    const timout = setTimeout(() => {
      if (show === true) logout();
    }, WARNING_BEFORE_LOGOUT_MS); //5 mins

    return () => clearTimeout(timout)
  }, [show])
  const handleShow = (isIdle = false) => {
    if (isIdle) {
      setShowMsg("You've been idle for a while!");
      setShow(true)

    } else {
     keepMeActive()
    }
  }

  return (
    <div>
    {/* {(userrole !== "record" || userrole !== "unit") && (
      <IdleTimer
        ref={idleTimerRef}
        timeout={6000000} //idle time 20 mins
        onIdle={onIdle}
      ></IdleTimer>
    )} */}



    {showPrompt && (
      <IdlePromptModal onContinue={handleContinue} onLogout={handleLogout} showPrompt={showPrompt} countdown={countdown} />
    )}
  </div>
  )
}

export default SessionIdleTimer
